/** Derive live phase from the latest WS frame (snapshot payload wins over stale HTTP D1). */
export function phaseFromLastWsMessage(msg: unknown): string | null {
	if (!msg || typeof msg !== "object") return null;
	const m = msg as { type?: string; phase?: string; payload?: { phase?: string } };
	if (m.type === "phase_change" && typeof m.phase === "string") return m.phase;
	if (m.type === "snapshot" && m.payload && typeof m.payload === "object") {
		const p = (m.payload as { phase?: string }).phase;
		if (typeof p === "string") return p;
	}
	return null;
}

/**
 * Prefer the current WS frame's phase, then a sticky phase from prior phase_change/snapshot,
 * then HTTP curator payload. Avoids reverting to stale D1 when presence_ping or other
 * non-phase frames overwrite `lastEvent`.
 */
export function resolveCuratorPhase(input: {
	lastEvent: unknown;
	stickyPhase: string | null;
	httpPhase: string | null | undefined;
}): string {
	return phaseFromLastWsMessage(input.lastEvent) ?? input.stickyPhase ?? input.httpPhase ?? "collecting";
}
